// Split trigger chip (label button + arrow button) for the TextNavbar menus —
// the menu BODIES it opens (Dropdown.QuickAdd / .AssistantMenu /
// .MoreFilesMenu / .MoreLearnMenu) are already on the MenuPanel chassis; this
// file owns only the trigger chrome. Bespoke-menus wave (§7.7/§4.3): the
// active chip's raw gray5/gray11 + white/black pairs move onto the house
// `selected` wash + `title` ink, and the inner Dropdown's `theme:
// 'common-box'` re-assert is dropped (it restated the brand Dropdown default).
export const TextNavbarButtonDropdown = {
  extends: 'DropdownButton',
  key: 'insert',
  isActive: (el) => {
    const explorer = el.getWindow('explorer')
    return explorer?.startsWith?.(el.key)
  },
  // `@dark`/`@light` inside a case block compile to `[data-theme="…"] &` rules
  // carrying `!important` (framework contract) — the only delivery strong
  // enough to beat the CanvasButton base chrome, so the active chip paints in
  // both themes. The VALUES are the §4.3 washes: `selected`/`title` are
  // adaptive pairs, so both scheme blocks carry the same tokens — the blocks
  // exist purely for the !important transform.
  //
  // A nested `':hover'` used to sit here with `@dark`/`@light` children. It was
  // unreachable twice over: the `[data-theme]` transform only applies at the
  // FIRST nesting level, so those children compiled to the non-matching
  // selectors `._cls:hover @dark` / `._cls:hover @light`; and even in the
  // canonical `'@dark': { ':hover': {} }` order the base rule's `!important`
  // beats a plain hover rule. Dropped rather than left emitting invalid CSS.
  '.isActive': {
    '@dark': {
      color: 'title',
      backgroundColor: 'selected'
    },
    '@light': {
      color: 'title',
      backgroundColor: 'selected'
    }
  },
  Button: {
    extends: 'TextNavbarButton',
    text: '{{ editor.insert.title | polyglot }}',
    icon: null,
    isActive: null,
    padding: 'Y2 Y1 Y2 Z2'
  },
  IconButton: {
    padding: 'Z Y2 Z Y',
    DropdownParentFocus: {
      inset: '0',
      position: 'absolute',
      Dropdown: {
        left: '-D2',
        onClick: () => {}
      }
    }
  }
}
